import { ticketSalesReportService } from "@/helpers/service/api/report";
import { json2csv_fn, salesStatus, toThousands } from "@/utils/common";
import locale from "@/helpers/locale";
import moment from "moment";
import { getExportName_fn, getOperatorText } from '@/utils/common'
export function exportCSV_fn(requestParma, filmList, startDate, endDate, weekLocaleArray) {
  ticketSalesReportService(requestParma).then(res => {
    if (res.data.records.length > 0) {
      let csvData = [];
      const fields = [
        {
          label: locale("trans.koisk.transid"),
          value: "searchId",
        },
        {
          label: locale("global.date"),
          value: "transactionCreateTime",
        },
        {
          label: locale("global.titleOfWork"),
          value: "filmName",
        },
        {
          label: locale("operation.NAT.screenDate"),
          value: "scheduleDate",
        },
        {
          label: locale("operation.NAT.showTime"),
          value: "scheduleTime",
        },
        {
          label: locale("global.screen"),
          value: "houseName",
        },
        {
          label: locale("theatre.seatType"),
          value: "seatName",
        },
        {
          label: locale("trans.report.ticketTypeName"),
          value: "ticketTypeName",
        },
        {
          label: locale("global.coupon"),
          value: "couponTypeName",
        },
        {
          label: locale("global.amount"),
          value: "total",
        },
        {
          label: locale("trans.report.paymentMethod"),
          value: "paymentName",
        },
        {
          label: locale("trans.userName"),
          value: "userName",
          
        },
        {
          label: locale("setting.brand.tel"),
          value: "mobile",
          
        },
        {
          label: locale("inventoryLog.changePeople"),
          value: "operator",
        },
        {
          label: locale("global.status"),
          value: "statusText",
        }
      ];
      res.data.records.forEach(item => {
        csvData.push({
          searchId: item.searchId + "\t",
          transactionCreateTime: moment(item.transactionCreateTime).format("YYYY-MM-DD HH:mm") + "\t",
          filmName: filmList.find(film => film.id === item.filmName) ? filmList.find(film => film.id === item.filmName).name : "",
          scheduleStartTime: moment(item.scheduleStartTime).format("YYYY-MM-DD HH:mm") + "\t",
          scheduleDate: moment(item.scheduleStartTime).format("YYYY-MM-DD"),
          scheduleTime: moment(item.scheduleStartTime).format("HH:mm"),
          houseName: item.houseName,
          seatName: item.seatName,
          ticketTypeName: item.ticketTypeName,
          couponTypeName: item.couponTypeName,
          total: item.total,
          paymentName: item.paymentName,
          userName: item.payerLastNameHant + item.payerFirstNameHant,
          mobile: item.mobile,
          operator: getOperatorText(item),
          statusText: salesStatus[item.itemStatus]
        });
      });
      // console.log(csvData);
      json2csv_fn(csvData, fields, 
      // moment().format("YYYYMMDDHHmm") + "_" + locale("sideMenu.reports.ticketTransaction")
      getExportName_fn(
        locale("sideMenu.reports.ticketTransaction"),
        '',
        '',
        '',
        `${moment(startDate).format('YYYY-MM-DD')} （${weekLocaleArray[moment(startDate).day()]}）~ ${moment(endDate).format('YYYY-MM-DD')} （${weekLocaleArray[moment(endDate).day()]}）`,
        res.data.cinemaName,
        moment().format('YYYYMMDDHHmm')
      )
      );
    }
  });
}